// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 96) return "content/vendors.d2212dedbae9241ddb3c.css";
	if (chunkId === 792) return "content/main.4472ad35c88c0c2e249b.css";
	// return url for filenames based on template
	return "content/" + chunkId + ".css";
};